import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageToggle.css';

export default function LanguageToggle({ compact = false }) {
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <button
      type="button"
      className={`language-toggle ${compact ? 'language-toggle--compact' : ''}`}
      onClick={toggleLanguage}
      aria-label={language === 'en' ? 'Cambiar el sitio a español' : 'Switch site to English'}
    >
      <span aria-hidden="true">{language === 'en' ? 'ES' : 'EN'}</span>
      {!compact && <strong>{t('languageName')}</strong>}
    </button>
  );
}
